import { createAsyncThunk } from '@reduxjs/toolkit';

import { pushMessage } from '@reducers/v2/messagesBus/messagesBus.slice';
import { ImageDocumentMessageType } from '@reducers/v2/messagesBus/types';
import { sendLog } from '@reducers/dataDogs';
import { LOGGER_TITLES } from '@reducers/dataDogs/constants';
import type { UploadImageDocumentMessageHandlerPayload } from '@reducers/v2/imageHandlingV2/messageHandlers';
import type { UploadImageDocumentSignalRResponse } from '@v2/components/imageHandling/types/types';
import type { AppDispatch } from '@store/types';

export const uploadImageDocumentMessageProducer = createAsyncThunk<void, UploadImageDocumentSignalRResponse, { dispatch: AppDispatch }>(
  'imageHandlingV2/uploadImageDocumentMessageProducer',
  async (params, { dispatch }) => {
    if (params.isError) {
      console.log('uploadImageDocumentMessageProducer error:', params.errorMessage, params);
      dispatch(
        sendLog({
          title: LOGGER_TITLES.UPLOAD_IMAGE_DOCUMENT_SIGNALR_ERROR,
          status: 'error',
          data: {
            errorMessage: params.errorMessage,
            documentBlobId: params.documentBlobId,
            documentId: params.documentId,
          },
        })
      );
      return;
    }

    const messagePayload: UploadImageDocumentMessageHandlerPayload = {
      documentBlobId: params.documentBlobId,
      documentId: params.documentId ?? params.image?.documentId,
      image: params.image,
    };

    if (!messagePayload.documentId) return;

    dispatch(
      pushMessage({
        key: messagePayload.documentId,
        message: {
          messageType: ImageDocumentMessageType.IMAGE_UPLOAD,
          payload: messagePayload,
        },
      })
    );
  }
);
